// Canonical copy for the unified client billing page ("الاشتراكات والفواتير"),
// per the v141 billing handoff spec. Kept separate from billing/admin's i18n
// tree since the admin console (out of scope here) reads that tree and the
// exact Arabic wording below is specific to this page.
const ar = {
  pageTitle: "الاشتراكات والفواتير",
  pageEyebrow: "LUD · حساب المطعم",
  activeBadge: "نشط",
  noneBadge: "لا يوجد اشتراك",
  pendingBadge: "قيد الانتظار",
  scheduledStopBadge: "مجدول للإيقاف",
  scheduledStartBadge: "مجدول للبدء",
  activationNote: "يُفعّل الاشتراك بعد اعتماد الدفعة من قسم المالية",
  branchesLabel: "عدد الفروع",
  coveredBranchesLabel: "الفروع المغطّاة",
  ofLabel: "من",
  awaitingPaymentBranchesLabel: "فروع بانتظار السداد",
  uncoveredBranchesLabel: "فروع غير مغطّاة",
  paidThroughLabel: "مدفوع حتى",
  renewalDateLabel: "تاريخ التجديد",
  grantedByLudLabel: "اشتراك ممنوح من لود حتى",
  freeCoverageEndsLabel: "تنتهي التغطية المجانية - ادفع الفاتورة قبل",
  currentPackageLabel: "الباقة الحالية",
  contextLoading: "جارٍ تحميل بيانات الحساب...",

  subscriptionsTitle: "الاشتراكات",
  ludEyebrow: "LUD",
  ludTitleTemplate: "اشتراك المنصة — باقة {package}",
  ludTitleNone: "لا يوجد اشتراك في منصة LUD",
  intgEyebrow: "Feed Us",
  intgTitle: "تكامل Feed Us",
  intgTitleNone: "لا يوجد تكامل Feed Us",
  intgGateNote: "يمكن تفعيل تكامل Feed Us لأي فرع ما دام اشتراك LUD فعّالًا لذلك الفرع",
  subscribeCta: "اشترك في باقة {package}",
  upgradeCta: "ترقية الباقة",
  manageCta: "إدارة الاشتراك",
  stopCta: "إيقاف الاشتراك",
  resumeCta: "استئناف",
  requestPending: "طلب قيد الانتظار",

  uncoveredTitle: "فروع بدون تغطية",
  uncoveredNone: "كل فروعك مغطّاة.",
  addCoverageCta: "إضافة تغطية",
  addCoverageNote: "تُحتسب التغطية الإضافية بسعرها الكامل لدورة الاشتراك الحالية (بدون تقسيم نسبي)، وتبدأ بعد اعتماد الدفع.",
  addCoverageDone: "تم إصدار فاتورة التغطية. ارفع إيصال التحويل من قسم الفواتير.",
  branchTrackTitle: "متابعة الفروع",
  branchTrackEmpty: "لا توجد فروع مشتركة حاليًا",
  colBranch: "الفرع",
  colStart: "البداية",
  colEnd: "النهاية",
  colRemaining: "المتبقي",
  colStatus: "الحالة",
  remainingDaysTemplate: "{days} يوم",
  remainingOpenEnded: "—",
  branchStatusActive: "نشط",
  branchStatusEnded: "منتهي",
  branchStatusScheduled: "مجدول",
  branchStatusSuspended: "موقوف",
  branchStatusCanceled: "ملغى",

  manageModalTitle: "إدارة الاشتراك",
  manageReadonlyNote: "الباقة والفروع والتواريخ تتحدث من الفواتير المدفوعة، ولا يمكن تعديلها أو حذفها أو إيقافها يدويًا",
  close: "إغلاق",

  catalogTitle: "الباقات والخدمات الإضافية",
  packageCatalogTitle: "الباقات",
  perMonth: "شهريًا",
  perBranchPerMonth: "لكل فرع / شهريًا",
  baseLabel: "السعر الأساسي",
  extraBranchLabel: "لكل فرع إضافي",
  featuresTitle: "المزايا",

  serviceCatalogTitle: "الخدمات الإضافية",
  requestCta: "طلب",
  requestPendingCta: "الطلب قيد المراجعة",
  perPhoto: "لكل صورة",
  perItem: "صنف",
  perBranchOnce: "لكل فرع",
  fixedPrice: "سعر ثابت",
  upToItems: "حتى {count} صنف",

  invoicesTitle: "الفواتير والمدفوعات",
  invoicesBanner: "فضلا بعد التحويل ارفع إيصال الدفع ليتم اعتماده من قسم المالية",
  paymentInstructionsTitle: "بيانات التحويل البنكي",
  paymentBank: "البنك",
  paymentAccountName: "اسم الحساب",
  paymentAccountNumber: "رقم الحساب",
  paymentIban: "الآيبان",
  needsActionPill: "تحتاج إجراء",
  groupAwaitingPayment: "بانتظار السداد",
  groupFinanceReview: "قيد مراجعة المالية",
  groupPaid: "مدفوعة",
  groupCancelled: "ملغاة",
  invoicesEmpty: "لا توجد فواتير",
  colInvoiceNumber: "رقم الفاتورة",
  colInvoiceLabel: "الباقة / الخدمة",
  colIssueDate: "تاريخ الإصدار",
  colAmount: "المبلغ",
  colDueDate: "تاريخ الاستحقاق",
  view: "عرض",

  invoiceDetailTitle: "تفاصيل الفاتورة",
  uploadReceiptCta: "رفع إيصال الدفع",

  subscribeModalTitle: "الاشتراك في باقة {package}",
  upgradeModalTitle: "ترقية إلى باقة {package}",
  intgSubscribeModalTitle: "الاشتراك في تكامل Feed Us",
  selectBranches: "اختر الفروع",
  noEligibleBranches: "لا توجد فروع متاحة لهذا الإجراء",
  ineligibleForIntg: "غير مؤهل — يتطلب اشتراك LUD فعّال",
  pricePreview: "معاينة السعر",
  subtotal: "الإجمالي الفرعي",
  vat: "الضريبة",
  total: "الإجمالي",
  confirmSubscribe: "إصدار الفاتورة",
  cancel: "إلغاء",
  submitting: "جارٍ الإرسال...",

  stopModalTitle: "إيقاف الاشتراك",
  stopReasonLabel: "سبب الإيقاف",
  stopReasonPlaceholder: "اذكر سببًا مختصرًا",
  confirmStop: "تأكيد الإيقاف",

  serviceOrderModalTitle: "طلب {service}",
  quantityLabel: "الكمية",
  monthsLabel: "عدد الأشهر",
  photosLabel: "عدد الصور",
  noteLabel: "ملاحظة (اختياري)",
  confirmOrder: "تأكيد الطلب",

  errorGeneric: "حدث خطأ، حاول مرة أخرى",
  retry: "إعادة المحاولة",
  loading: "جارٍ التحميل...",
};

const en = {
  pageTitle: "Subscriptions & Invoices",
  pageEyebrow: "LUD · Restaurant account",
  activeBadge: "Active",
  noneBadge: "No subscription",
  pendingBadge: "Pending",
  scheduledStopBadge: "Scheduled to stop",
  scheduledStartBadge: "Scheduled to start",
  activationNote: "Subscription activates once Finance approves the payment",
  branchesLabel: "Branches",
  coveredBranchesLabel: "Covered branches",
  ofLabel: "of",
  awaitingPaymentBranchesLabel: "Branches awaiting payment",
  uncoveredBranchesLabel: "Uncovered branches",
  paidThroughLabel: "Paid through",
  renewalDateLabel: "Renewal date",
  grantedByLudLabel: "Subscription granted by LUD until",
  freeCoverageEndsLabel: "Free coverage ends - pay the invoice before",
  currentPackageLabel: "Current package",
  contextLoading: "Loading account data...",

  subscriptionsTitle: "Subscriptions",
  ludEyebrow: "LUD",
  ludTitleTemplate: "Platform subscription — Package {package}",
  ludTitleNone: "No LUD platform subscription",
  intgEyebrow: "Feed Us",
  intgTitle: "Feed Us integration",
  intgTitleNone: "No Feed Us integration",
  intgGateNote: "Feed Us integration can be activated for a branch as long as LUD is active for that branch",
  subscribeCta: "Subscribe to Package {package}",
  upgradeCta: "Upgrade package",
  manageCta: "Manage subscription",
  stopCta: "Stop subscription",
  resumeCta: "Resume",
  requestPending: "Request pending",

  uncoveredTitle: "Branches without coverage",
  uncoveredNone: "All your branches are covered.",
  addCoverageCta: "Add coverage",
  addCoverageNote: "Extra coverage is charged at its full price for the current subscription cycle (no proration) and starts once the payment is approved.",
  addCoverageDone: "The coverage invoice was issued. Upload the transfer receipt from the invoices section.",
  branchTrackTitle: "Branch tracking",
  branchTrackEmpty: "No branches currently covered",
  colBranch: "Branch",
  colStart: "Start",
  colEnd: "End",
  colRemaining: "Remaining",
  colStatus: "Status",
  remainingDaysTemplate: "{days} days",
  remainingOpenEnded: "—",
  branchStatusActive: "Active",
  branchStatusEnded: "Ended",
  branchStatusScheduled: "Scheduled",
  branchStatusSuspended: "Suspended",
  branchStatusCanceled: "Canceled",

  manageModalTitle: "Manage subscription",
  manageReadonlyNote: "Package, branches, and dates are derived from paid invoices and cannot be manually edited, deleted, or stopped",
  close: "Close",

  catalogTitle: "Packages & additional services",
  packageCatalogTitle: "Packages",
  perMonth: "per month",
  perBranchPerMonth: "per branch / month",
  baseLabel: "Base price",
  extraBranchLabel: "per extra branch",
  featuresTitle: "Features",

  serviceCatalogTitle: "Additional services",
  requestCta: "Request",
  requestPendingCta: "Request under review",
  perPhoto: "per photo",
  perItem: "item",
  perBranchOnce: "per branch",
  fixedPrice: "fixed price",
  upToItems: "up to {count} items",

  invoicesTitle: "Invoices & Payments",
  invoicesBanner: "After transferring, please upload the payment receipt so Finance can approve it",
  paymentInstructionsTitle: "Bank transfer details",
  paymentBank: "Bank",
  paymentAccountName: "Account name",
  paymentAccountNumber: "Account number",
  paymentIban: "IBAN",
  needsActionPill: "Needs action",
  groupAwaitingPayment: "Awaiting payment",
  groupFinanceReview: "Under finance review",
  groupPaid: "Paid",
  groupCancelled: "Cancelled",
  invoicesEmpty: "No invoices",
  colInvoiceNumber: "Invoice #",
  colInvoiceLabel: "Package / Service",
  colIssueDate: "Issue date",
  colAmount: "Amount",
  colDueDate: "Due date",
  view: "View",

  invoiceDetailTitle: "Invoice details",
  uploadReceiptCta: "Upload receipt",

  subscribeModalTitle: "Subscribe to Package {package}",
  upgradeModalTitle: "Upgrade to Package {package}",
  intgSubscribeModalTitle: "Subscribe to Feed Us integration",
  selectBranches: "Select branches",
  noEligibleBranches: "No branches available for this action",
  ineligibleForIntg: "Not eligible — requires active LUD",
  pricePreview: "Price preview",
  subtotal: "Subtotal",
  vat: "VAT",
  total: "Total",
  confirmSubscribe: "Issue invoice",
  cancel: "Cancel",
  submitting: "Submitting...",

  stopModalTitle: "Stop subscription",
  stopReasonLabel: "Reason for stopping",
  stopReasonPlaceholder: "Give a short reason",
  confirmStop: "Confirm stop",

  serviceOrderModalTitle: "Request {service}",
  quantityLabel: "Quantity",
  monthsLabel: "Number of months",
  photosLabel: "Number of photos",
  noteLabel: "Note (optional)",
  confirmOrder: "Confirm request",

  errorGeneric: "Something went wrong, please try again",
  retry: "Retry",
  loading: "Loading...",
};

export function useClientBillingText(lang = "ar") {
  return lang === "en" ? en : ar;
}

export function fillTemplate(template, values = {}) {
  return Object.entries(values).reduce(
    (result, [key, value]) => result.replaceAll(`{${key}}`, value),
    template || "",
  );
}

export const BRANCH_STATUS_LABEL_KEY = {
  active: "branchStatusActive",
  ended: "branchStatusEnded",
  scheduled: "branchStatusScheduled",
  suspended: "branchStatusSuspended",
  canceled: "branchStatusCanceled",
};
